import './index.css'
import Title from './Title';
import GameReleasedTitle from './GameReleasedTitle'
import GameCard from './GameCard';
import {gameInfo} from './ReleasedGames';
import Footer  from './Footer';
import MiniCard from './MiniCard';
import {Routes , Route} from 'react-router-dom';
import GameInfo from './GameInfo';
import CreateVideoList from './CreateVideoList';

var allWebStages = 
[
    'Home','Tame The Beast','Devil Knight'
]

var selectedStage ;
var activetitle;
var game_releasedTitle;


  const Home = function()
  {
    return (
      <div className="App">
        {window.scrollTo(0, 0)}
      <Title />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
     

      <GameReleasedTitle />

        <div id='cardHolder'>
       
        
       { HandleWebStages(0)}
       

        </div>

        <div>
          <Footer />
        </div>
    </div>
    );
  }


  const TameTheBeast = function()
  {
    return (
      <div className="App">
     {window.scrollTo(0, 0)}

      <Title />
      <br></br>
      <br></br>   
      <br></br>
      <br></br>
     

      <GameReleasedTitle />

{/* Showing Game Info */}
      <GameInfo ginfo = {gameInfo[0].info} />

      

{/* Creating Video List */}
      <CreateVideoList num ={0} />

     

        <div className='videoTitleHolder'>
          <p> Picture Gallery</p>
        </div>
        <div id='cardHolder'>

        
{/* Handeling WebStages */}
        { HandleWebStages(1)}
       

        </div>
        
        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <div className = "downloadLink">
         
            <a className='downloadLink2' href= "https://play.google.com/store/apps/details?id=com.EkOnkarGames.BeastTamers" rel="noopener noreferrer" target="_blank">
                <img className='linkPic' src='./google-play-badge.png' alt='downloadPic'/>
            </a>
         
        </div>

        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <div>
          <Footer />
        </div>
    </div>
    );
  }

  const DevilKnight = function()
  {
    return (
      <div className="App">
     {window.scrollTo(0, 0)}
      <Title />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
     

      <GameReleasedTitle />

      <GameInfo ginfo = {gameInfo[1].info} />

        <div className='VideoHolder'>
          <CreateVideoList num ={1} />
        
        </div>

        <div className='videoTitleHolder'>
          <p> Picture Gallery</p>
        </div>

        <div id='cardHolder'>

        
        { HandleWebStages(2)}
       

        </div>

        <br></br>
        <br></br>
        <br></br>
        <br></br>

        <div className = "downloadLink">

              <a className='downloadLink2' href= "https://play.google.com/store/apps/details?id=com.EkonkarGames.DevilKnight&hl=en&gl=US" rel="noopener noreferrer" target="_blank">
                  <img className='linkPic' src='./google-play-badge.png' alt='downloadPic'/>
              </a>      

        </div>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <div>
          <Footer />
        </div>
    </div>
    );
  }


 const App = function () {
  return (
        <Routes>
          <Route exact path='/' element ={<Home />} />

          <Route path='/tameTheBeast' element={<TameTheBeast />} />          

          <Route path='/devilknight' element ={<DevilKnight />} />
              
        </Routes>   
  );
}

export default App;

let cardGenrated = [];
function CreateReleasedGameCards()
{
  for(let i=0; i <gameInfo.length; i++)
  {
      cardGenrated[i] = (<GameCard key ={i} title ={gameInfo[i].title} cardPic = {gameInfo[i].preview_pic} info ={gameInfo[i].info} link = {gameInfo[i].gamePageLink} />)
  }
 return cardGenrated;
}

function HandleWebStages(v)
{
  selectedStage = allWebStages[v];
    switch (selectedStage)
    {
        case 'Home':
        console.log(selectedStage);
        ChangeActiveTitle('Game Released');
        return CreateReleasedGameCards();
        

        case 'Tame The Beast':
        ChangeActiveTitle('Tame The Beast');
       return CreateGameInfo(FindGameInfo(selectedStage));

        case 'Devil Knight':
          ChangeActiveTitle('Devil Knight');       
        return CreateGameInfo(FindGameInfo(selectedStage));

        default:
          console.log(v + " Not Found");
          break;
    }
}

function FindGameInfo(v)
{
  for (let i=0; i <gameInfo.length; i++)
  {
    if (v === gameInfo[i].title)
    {
     // console.log(gameInfo[i].title);      
      return gameInfo[i];
    }
  }
}

var miniCardsGenrated = [];
function CreateGameInfo(game_info)
{
 // console.log(game_info);
  for (let i=0; i <game_info.allGamePics.length; i++)
  {
   // console.log(game_info.allGamePics[i]);
   miniCardsGenrated[i] = <MiniCard key = {i} gameTitle = {gameInfo.title} pic ={game_info.allGamePics[i]}/>;
  }
  return miniCardsGenrated;
}

 
function ChangeActiveTitle(v)
{  
  activetitle = v;

  setTimeout(AddDelayToChangeTitle,50);
}


function AddDelayToChangeTitle()
{
  console.log(activetitle + " Value");
  game_releasedTitle = document.getElementById('game_releasedTitle');
  if (game_releasedTitle != null)
  {
    game_releasedTitle.innerHTML = activetitle;
  }
  else 
  {
    console.log(game_releasedTitle + " Is Null");
  }
}



